import Model from "../Model";

class Company extends Model{

    buildUrl ({ param }) {
        return ['companyview', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Company;